import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-6 py-9" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "flex gap-4" }

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';

import { useSearchClients } from '../composables/useSearchClients';

import { useClientFileHandler } from '../composables/useClientFileHandler';

import JsonUpload from '../components/JsonUpload.vue';
import ClientDeleteButton from '../components/ClientDeleteButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsView',
  setup(__props) {

const { search, searchedClients } = useSearchClients();

const { isLoading, addClientFromFile } = useClientFileHandler();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "mr-auto font-lora text-3xl text-gray-900" }, "Lista moich klientów", -1)),
      _createVNode(_unref(IconField), { class: "w-[430px]" }, {
        default: _withCtx(() => [
          _createVNode(_unref(InputIcon), { class: "pi pi-search" }),
          _createVNode(_unref(InputText), {
            class: "w-[430px]",
            modelValue: _unref(search),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : null)),
            placeholder: "Szukaj"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        to: `/${_ctx.$route.params.calculatorId}/client/new`
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), { size: "small" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "pi pi-user-plus" }, null, -1),
              _createTextVNode(" Nowy klient ")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(JsonUpload, {
        chooseLabel: "Dodaj z pliku",
        isLoading: _unref(isLoading),
        onUpdate: _unref(addClientFromFile)
      }, null, 8, ["isLoading", "onUpdate"])
    ]),
    _createVNode(_unref(DataTable), {
      class: "overflow-hidden rounded-xl border border-gray-200 [&__.p-row-odd]:bg-gray-50",
      value: _unref(searchedClients),
      rowClass: (data) => [{ '!bg-red-100': data.outdated }],
      dataKey: "uuid",
      removableSort: "",
      tableStyle: "min-width: 50rem"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "owner.email",
          header: "DTH",
          sortable: true,
          style: {"width":"20%"}
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.owner ? `${data.owner.first_name ?? ''} ${data.owner.last_name ?? ''}`.trim() || '—' : '—'), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Imię i nazwisko",
          style: {"width":"20%"}
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.first_name) + " " + _toDisplayString(data.last_name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "email",
          header: "Adres e-mail",
          sortable: "",
          style: {"width":"20%"}
        }),
        _createVNode(_unref(Column), {
          field: "province",
          header: "Województwo",
          sortable: "",
          style: {"width":"20%"}
        }),
        _createVNode(_unref(Column), {
          field: "phone",
          header: "Numer telefonu",
          sortable: "",
          style: {"width":"20%"}
        }),
        _createVNode(_unref(Column), { header: "" }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_RouterLink, {
                to: `/${_ctx.$route.params.calculatorId}/client/${data.uuid}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    class: "!p-2",
                    size: "small",
                    severity: "secondary",
                    outlined: ""
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "pi pi-pen-to-square" }, null, -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["to"]),
              (data.id)
                ? (_openBlock(), _createBlock(ClientDeleteButton, {
                    key: 0,
                    clientId: data.id
                  }, null, 8, ["clientId"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "rowClass"])
  ]))
}
}

})